import { FC } from 'react';

import {
  DateFilter,
  ScheduledSocialPostSection,
} from '@screens/entertainer/DragKingCommunityScreen/ScheduledSocialPost';

export const SeriesManageScheduledSocialPost: FC<{
  cityId: string;
  recommendationModeEnabled?: boolean;
  dateFilter?: DateFilter;
}> = ({ cityId, recommendationModeEnabled, dateFilter }) => {
  return (
    <ScheduledSocialPostSection
      recommendationModeEnabled={recommendationModeEnabled}
      hideIndividualFeatureTitle
      cityId={cityId}
      description={`These are all the flyers that have been uploaded. Check if a show already exists and press "Add Flyer" to add a new one.`}
      dateFilter={dateFilter}
    />
  );
};
